import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Analise, Projeto } from '../models/analise';


/**
 * Componente de diálogo de exclusão de Projeto ou Análise.
 */
@Component({
  selector: 'app-remove-dialog',
  templateUrl: './remove-dialog.component.html',
})
export class RemoveDialogComponent implements OnInit {

  /**
   * Construtor.
   * @param dialogRef referência ao dialog
   * @param data referência ao objeto de dados passado na abertura do dialog.
   */
  constructor(
    public dialogRef: MatDialogRef<RemoveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

    
  ngOnInit(): void {

  }

  /** Trata o fechamento do dialog ao clicar no botão de confirmação. */
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  /** Trata o fechamento do dialog ao clicar no botão de cancelamento. */
  onCancel():void{
    this.dialogRef.close(false);
  }

}
